export default __webpack_public_path__ + "static/media/hht1_home_img_EP15.8a123b3b.png";